"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEnvironment = exports.settingEnvironment = exports.showVersionsList = exports.showFulfillmentConfigurationsList = void 0;

var _actiontypes = _interopRequireDefault(require("./actiontypes"));

/* Basic Actions */
var showFulfillmentConfigurationsList = function showFulfillmentConfigurationsList() {
  return {
    type: _actiontypes["default"].SHOW_FULFILLMENT_CONFIGURATIONS_LIST
  };
};

exports.showFulfillmentConfigurationsList = showFulfillmentConfigurationsList;

var showVersionsList = function showVersionsList() {
  return {
    type: _actiontypes["default"].SHOW_VERSIONS_LIST
  };
};

exports.showVersionsList = showVersionsList;

var settingEnvironment = function settingEnvironment(_ref) {
  var environment = _ref.environment;
  return {
    type: _actiontypes["default"].SETTING_ENVIRONMENT,
    environment: environment
  };
};
/* Advanced/Thunk Actions */

/**
 * Sets the environment of the component
 * @param {string} environment A string that represents the environment of the parent application. Must be 'int' or 'prd'.
 */


exports.settingEnvironment = settingEnvironment;

var setEnvironment = function setEnvironment(_ref2) {
  var environment = _ref2.environment;
  return function (dispatch) {
    dispatch(settingEnvironment({
      environment: environment
    }));
  };
};

exports.setEnvironment = setEnvironment;